export const HOME = {
  homeLink: "home-link",
};

export const LANDING = {
  // Navbar
  navLogo: "nav-logo",
  navHomeLink: "nav-home-link",
  navFeaturesLink: "nav-features-link",
  navPricingLink: "nav-pricing-link",
  navAboutLink: "nav-about-link",
  navSupportLink: "nav-support-link",
  navContactLink: "nav-contact-link",
  navHowItWorksLink: "nav-how-it-works-link",
  navFaqLink: "nav-faq-link",
  navGetStarted: "nav-get-started-btn",
  navMobileToggle: "nav-mobile-toggle",

  // Hero
  heroGetStarted: "hero-get-started-btn",
  heroBookDemo: "hero-book-demo-btn",
  heroHowItWorks: "hero-how-it-works-btn",
  heroPlayBadge: "hero-google-play-badge",
  heroAppStoreBadge: "hero-app-store-badge",

  // Sections
  trustedBy: "trusted-by-section",
  problem: "problem-section",
  solution: "solution-section",
  features: "features-section",
  offlineFirst: "offline-first-section",
  analytics: "analytics-section",
  staffBranch: "staff-branch-section",
  debt: "debt-section",
  multilingual: "multilingual-section",
  howItWorks: "how-it-works-section",
  pricing: "pricing-section",
  testimonials: "testimonials-section",
  faq: "faq-section",
  finalCta: "final-cta-section",
  footer: "footer-section",

  faqItem: (i) => `faq-item-${i}`,

  // CTAs
  ctaTalkSales: "cta-talk-sales-btn",
  ctaEarlyAccess: "cta-early-access-btn",
  ctaStartManaging: "cta-start-managing-btn",
  ctaFooterPlayBadge: "footer-google-play-badge",
  ctaFooterAppStoreBadge: "footer-app-store-badge",

  // Footer
  footerPrivacy: "footer-privacy-link",
  footerTerms: "footer-terms-link",
  footerSupport: "footer-support-link",
  footerContact: "footer-contact-link",
  footerAccountDeletion: "footer-account-deletion-link",
};

export const PAGES = {
  // Generic page CTAs
  pageHeroPrimary: "page-hero-primary-cta",
  pageHeroSecondary: "page-hero-secondary-cta",
  pageBottomCta: "page-bottom-cta-btn",
  pageContactBtn: "page-contact-btn",

  // Contact form
  contactNameInput: "contact-name-input",
  contactEmailInput: "contact-email-input",
  contactPhoneInput: "contact-phone-input",
  contactMessageInput: "contact-message-textarea",
  contactSubmit: "contact-submit-btn",
  contactWhatsappBtn: "contact-whatsapp-btn",
  contactEmailBtn: "contact-email-btn",

  // Pricing
  pricingCardSolo: "pricing-card-solo",
  pricingCardStarter: "pricing-card-starter",
  pricingCardGrowth: "pricing-card-growth",
  pricingCardEnterprise: "pricing-card-enterprise",
  pricingCtaStarter: "pricing-cta-starter",
  pricingCtaSolo: "pricing-cta-solo",
  pricingCtaGrowth: "pricing-cta-growth",
  pricingCtaEnterprise: "pricing-cta-enterprise",
};
